export class CustomEventTrackingData {
    /**
     * @type {string}
     */
    static CUSTOM_EVENT_TRACKING_DATA_ID_KEY = 'id';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_TRACKING_DATA_NAME_KEY = 'name';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_TRACKING_DATA_PRICE_KEY = 'price';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_TRACKING_DATA_CATEGORY_KEY = 'category';

    /**
     * @type {number}
     */
    id = 0;

    /**
     * @type {string}
     */
    name = '';

    /**
     * @type {number}
     */
    price = 0.0;

    /**
     * @type {string}
     */
    category = '';

    /**
     * @param data
     */
    constructor(data) {

        this.id = data[CustomEventTrackingData.CUSTOM_EVENT_TRACKING_DATA_ID_KEY] ?? 0;
        this.name = data[CustomEventTrackingData.CUSTOM_EVENT_TRACKING_DATA_NAME_KEY] ?? '';
        this.price = data[CustomEventTrackingData.CUSTOM_EVENT_TRACKING_DATA_PRICE_KEY] ?? 0.0;
        this.category = data[CustomEventTrackingData.CUSTOM_EVENT_TRACKING_DATA_CATEGORY_KEY] ?? '';
    }

    /**
     * @returns {boolean}
     */
    isValid() {

        if (this.id === 0) {

            return false;
        }

        if (this.name === '') {

            return false;
        }

        if (this.price === 0.0) {

            return false;
        }

        if (this.category === '') {

            return false;
        }

        return true;
    }
}